export type ReactChatbotLang = 'es' | 'en';

export interface ReactChatbotStrings {
  newConversation: string;
  searchChat: string;
  sectionPlaceholder: string;
  typeMessage: string;
  noConversations: string;
  botTitle: string;
  botSubtitle: string;
  confirmDelete: string;
  confirmDeleteText: string;
  cancel: string;
  delete: string;
  deleting: string;
  chatDeleted: string;
  deleteOption: string;
  sessionExpiredTitle: string;
  sessionExpiredText: string;
  noResults: string;
  nameColumn: string;
  newConversationTitle: string;
  backAria: string;
  selectOption: string;
  expandDetailAria: string;
  collapseDetailAria: string;
  assistantTitle: string;
  assistantBadge: string;
  poweredByAI: string;
  shortcutGenerateCommissionsReport: string;
  shortcutHowToCreateClient: string;
  shortcutViewCommissions: string;
}

export const reactChatbotLocales: Record<ReactChatbotLang, ReactChatbotStrings> = {
  en: {
    newConversation: 'New Conversation',
    searchChat: 'Search chat...',
    sectionPlaceholder: 'Section (optional)',
    typeMessage: 'Type a message...',
    noConversations: 'No conversations',
    botTitle: 'Chatbot',
    botSubtitle: 'Ask me anything you need about the CRM.',
    confirmDelete: 'Confirm Deletion',
    confirmDeleteText: 'Are you sure you want to delete this conversation? This action cannot be undone.',
    cancel: 'Cancel',
    delete: 'Delete',
    deleting: 'Deleting...',
    chatDeleted: 'Chat deleted successfully',
    deleteOption: 'Delete',
    sessionExpiredTitle: 'Session expired',
    sessionExpiredText: 'Your session has expired. Close this window and reopen it to continue.',
    noResults: 'No results found',
    nameColumn: 'Name',
    newConversationTitle: 'New conversation',
    backAria: 'Back to conversations',
    selectOption: 'Select this option',
    expandDetailAria: 'Expand detail',
    collapseDetailAria: 'Collapse detail',
    assistantTitle: 'Assistant',
    assistantBadge: 'AI',
    poweredByAI: 'Powered by AI',
    shortcutGenerateCommissionsReport: 'How can I generate a commissions report?',
    shortcutHowToCreateClient: 'How do I create a new client?',
    shortcutViewCommissions: 'View my commissions',
  },
  es: {
    newConversation: 'Nueva Conversación',
    searchChat: 'Buscar chat...',
    sectionPlaceholder: 'Sección (opcional)',
    typeMessage: 'Escribe un mensaje...',
    noConversations: 'No hay conversaciones',
    botTitle: 'Chatbot',
    botSubtitle: 'Preguntame lo que necesites sobre el CRM.',
    confirmDelete: 'Confirmar Eliminación',
    confirmDeleteText: '¿Está seguro que desea eliminar esta conversación? Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    deleting: 'Eliminando...',
    chatDeleted: 'Chat eliminado exitosamente',
    deleteOption: 'Eliminar',
    sessionExpiredTitle: 'Sesión expirada',
    sessionExpiredText: 'Tu sesión ha expirado. Cierra esta ventana y vuelve a abrirla para continuar.',
    noResults: 'No se encontraron resultados',
    nameColumn: 'Nombre',
    newConversationTitle: 'Nueva conversación',
    backAria: 'Volver a conversaciones',
    selectOption: 'Seleccionar esta opción',
    expandDetailAria: 'Expandir detalle',
    collapseDetailAria: 'Colapsar detalle',
    assistantTitle: 'Asistente',
    assistantBadge: 'IA',
    poweredByAI: 'Potenciado por IA',
    shortcutGenerateCommissionsReport: '¿Cómo puedo generar un reporte de comisiones?',
    shortcutHowToCreateClient: '¿Cómo creo un nuevo cliente?',
    shortcutViewCommissions: 'Ver mis comisiones',
  },
};
